import React from 'react';

export function Footer() {
  return (
    <footer className='w-full text-center h-11'>
      <p className='text-slate-700 dark:text-white'>
        @Copyright 2021 | Made with ❤️ Rolando Pranata
      </p>
    </footer>
  );
}
